import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { TableCell } from '../TableCell/index.js';
import { TableCellContentType } from '../TableCell/types.js';
import { TableRow } from '../TableRow/index.js';
import { TableLoaderBar } from './styled.js';
export const TableLoader = memo(function TableLoader({ columnsLength, rows = 3, dataTestId }) {
    const rowsArray = useMemo(() => [...Array.from({ length: rows }, (_, i) => i)], [rows]);
    const columnsArray = useMemo(() => [...Array.from({ length: columnsLength }, (_, i) => i)], [columnsLength]);
    return (_jsx(_Fragment, { children: rowsArray.map((i) => (_jsx(TableRow, { dataTestId: dataTestId, children: columnsArray.map((j) => (_jsx(TableCell, { contentType: TableCellContentType.LOADING, children: _jsx(TableLoaderBar, {}) }, j))) }, i))) }));
});
